<template>
    <div class="info-icon-container">
      <span class="info-icon" @mouseover="showInfo" @mouseleave="hideInfo">ⓘ</span>
  
      <!-- Info modal/balloon -->
      <div v-if="isInfoVisible" class="info-modal">
        <p class="info-text">
          <slot></slot>
        </p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isInfoVisible: false,
      };
    },
    methods: {
      showInfo() {
        this.isInfoVisible = true;
      },
      hideInfo() {
        this.isInfoVisible = false;
      },
    },
  };
  </script>
  
  <style scoped>
  .info-icon-container {
    position: relative;
    display: inline-block; /* Preserve inline layout for adjacent elements */
  }
  
  .info-icon {
    cursor: pointer;
    font-size: 20px;
    color: #007bff; /* Your preferred color */
  }
  
  .info-modal {
    position: absolute;
    background-color: #fff;
    border: 1px solid #ccc;
    padding: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    width: 500px; /* Your preferred width */
    top: 30px; /* Adjusted top position for better visibility */
    left: 50%; /* Center the modal horizontally */
    transform: translateX(-50%); /* Center the modal horizontally */
    text-align: center; /* Center the text within the modal */
  }
  
  .info-text {
    text-align: justify;
    font-family: inherit; /* Inherit font family from the closest parent element */
    /* Add other styling as needed */
  }
  </style>
  